import { GeocoderAutocompleteOptions } from "../autocomplete";
import countiesData from "../countries.json";

export class DomHelper {
    public static createInputElement(inputElement: HTMLInputElement,
                                      options: GeocoderAutocompleteOptions,
                                      container: HTMLElement): HTMLElement {
        inputElement.classList.add("geoapify-autocomplete-input");
        inputElement.setAttribute("type", "text");
        inputElement.setAttribute("placeholder", options.placeholder || "Enter an address here");
        
        // Create wrapper for input and close button
        const inputWrapper = document.createElement("div");
        inputWrapper.classList.add("geoapify-input-wrapper");
        inputWrapper.appendChild(inputElement);
        container.appendChild(inputWrapper);
        
        return inputWrapper;
    }

    public static addFeatureIcon(element: HTMLElement, type: string, countryCode: string) {
        const iconMap: any = {
            'unknown': 'map-marker',
            'amenity': 'map-marker',
            'building': 'map-marker',
            'street': 'road',
            'suburb': 'city',
            'district': 'city',
            'postcode': 'city',
            'city': 'city',
            'county': 'city',
            'state': 'city'
        };

        const countryData = countiesData.find(county => countryCode && county.code.toLowerCase() === countryCode.toLowerCase());

        if ((type === 'country') && countryData) {
            element.classList.add("emoji");
            const emojiElement = document.createElement('span');
            emojiElement.innerText = countryData.emoji;
            element.appendChild(emojiElement);
        } else if (iconMap[type]) {
            this.addIcon(element, iconMap[type])
        } else {
            this.addIcon(element, 'map-marker');
        }
    }


    public static addIcon(element: HTMLElement, icon: string) {

        //FortAwesome icons 5. Licence - https://fontawesome.com/license/free

        const icons: { [key: string]: any } = {
            "close": {
                path: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
                viewbox: "0 0 24 24"
            },
            "map-marker": {
                path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                viewbox: "0 0 384 512"
            },
            "road": {
                path: "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z",
                viewbox: "0 0 576 512"
            },
            "city": {
                path: "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z",
                viewbox: "0 0 640 512"
            },
            "chevron-down": {
                path: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z",
                viewbox: "0 0 512 512"
            },
            "spinner": {
                path: "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z",
                viewbox: "0 0 512 512"
            },
            "clock": {
                path: "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z",
                viewbox: "0 0 512 512"
            },
            "search": {
                path: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z",
                viewbox: "0 0 512 512"
            },
            "ban": {
                path: "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z",
                viewbox: "0 0 512 512"
            },
            "filter": {
                path: "M0 73.7C0 50.7 18.7 32 41.7 32H470.3c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5V447.7c0 17.8-14.5 32.3-32.3 32.3c-7.1 0-14-2.3-19.6-6.6L176.2 399.6c-10.1-7.7-16.2-19.8-16.2-32.7V304.5L-9.4 100C-3.3 92.6 0 83.3 0 73.7z",
                viewbox: "0 0 512 512"
            }
        }

        var svgElement = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
        svgElement.setAttribute('viewBox', icons[icon].viewbox);
        svgElement.setAttribute('height', "18");

        var iconElement = document.createElementNS("http://www.w3.org/2000/svg", 'path');
        iconElement.setAttribute("d", icons[icon].path);
        iconElement.setAttribute('fill', 'currentColor');
        svgElement.appendChild(iconElement);
        element.appendChild(svgElement);
    }

    public static addSpinnerIcon(element: HTMLElement) {
        const svgElement = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
        svgElement.setAttribute('viewBox', '0 0 512 512');
        svgElement.setAttribute('class', 'geoapify-places-spinner-icon');

        const iconElement = document.createElementNS("http://www.w3.org/2000/svg", 'path');
        iconElement.setAttribute("d", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z");
        iconElement.setAttribute('fill', 'currentColor');
        svgElement.appendChild(iconElement);
        element.appendChild(svgElement);
    }

    private static appendHighlightedText(element: HTMLElement, value: string, currentValue: string): void {
        const valueIndex = currentValue
            ? value.toLowerCase().indexOf(currentValue.toLowerCase())
            : -1;

        if (valueIndex < 0) {
            element.textContent = value;
            return;
        }

        element.appendChild(document.createTextNode(value.substring(0, valueIndex)));

        const highlightedElement = document.createElement("strong");
        highlightedElement.textContent = value.substring(valueIndex, valueIndex + currentValue.length);
        element.appendChild(highlightedElement);

        element.appendChild(document.createTextNode(value.substring(valueIndex + currentValue.length)));
    }

    private static appendNonVerifiedText(element: HTMLElement, value: string, nonVerifiedValues: string[]): void {
        const ranges = nonVerifiedValues
            .filter(nonVerifiedValue => nonVerifiedValue)
            .map(nonVerifiedValue => {
                const start = value.indexOf(nonVerifiedValue);
                return { start, end: start + nonVerifiedValue.length };
            })
            .filter(range => range.start >= 0)
            .sort((range1, range2) => range1.start - range2.start);

        let currentIndex = 0;
        ranges.forEach(range => {
            if (range.start < currentIndex) {
                return;
            }

            element.appendChild(document.createTextNode(value.substring(currentIndex, range.start)));

            const nonVerifiedElement = document.createElement("span");
            nonVerifiedElement.classList.add("non-verified");
            nonVerifiedElement.textContent = value.substring(range.start, range.end);
            element.appendChild(nonVerifiedElement);

            currentIndex = range.end;
        });

        element.appendChild(document.createTextNode(value.substring(currentIndex)));
    }

    public static getStyledAddressSingleValue(value: string, currentValue: string): HTMLElement {
        const mainPartElement = document.createElement("span");
        mainPartElement.classList.add("main-part");
        DomHelper.appendHighlightedText(mainPartElement, String(value ?? ""), currentValue);
        return mainPartElement;
    }

    public static getStyledAddress(featureProperties: any, currentValue: string): DocumentFragment {
        let mainPart: string;
        let secondaryPart: string;
        const formatted = String(featureProperties.formatted ?? "");
        const parts = formatted.split(',').map((part: string) => part.trim());

        if (featureProperties.name) {
            mainPart = parts[0];
            secondaryPart = parts.slice(1).join(', ');
        } else {
            const mainElements = Math.min(2, Math.max(parts.length - 2, 1));
            mainPart = parts.slice(0, mainElements).join(', ');
            secondaryPart = parts.slice(mainElements).join(', ');
        }

        const fragment = document.createDocumentFragment();
        const mainPartElement = document.createElement("span");
        mainPartElement.classList.add("main-part");

        if (featureProperties.nonVerifiedParts?.length) {
            const nonVerifiedValues = featureProperties.nonVerifiedParts
                .map((part: string) => featureProperties[part])
                .filter((value: unknown): value is string => typeof value === "string");
            DomHelper.appendNonVerifiedText(mainPartElement, mainPart, nonVerifiedValues);
        } else {
            DomHelper.appendHighlightedText(mainPartElement, mainPart, currentValue);
        }

        const secondaryPartElement = document.createElement("span");
        secondaryPartElement.classList.add("secondary-part");
        secondaryPartElement.textContent = secondaryPart;

        fragment.appendChild(mainPartElement);
        fragment.appendChild(secondaryPartElement);
        return fragment;
    }

    public static addDropdownIcon(feature: any, itemElement: HTMLDivElement) {
        const iconElement = document.createElement("span");
        iconElement.classList.add('icon');

        DomHelper.addFeatureIcon(iconElement, feature.properties.result_type, feature.properties.country_code);

        itemElement.appendChild(iconElement);
    }

    public static addActiveClassToDropdownItem(items: HTMLCollectionOf<HTMLDivElement>, index: number) {
        for (var i = 0; i < items.length; i++) {
            items[i].classList.remove("active");
        }

        /* Add class "autocomplete-active" to the active element*/
        items[index].classList.add("active");
    }

    public static createDropdownItemText() {
        const textElement = document.createElement("span");
        textElement.classList.add('address');
        return textElement;
    }

    public static createDropdownItem() {
        const itemElement = document.createElement("div");
        itemElement.classList.add('geoapify-autocomplete-item');
        return itemElement;
    }
}
